var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 44,
    viewBox: "0 0 56 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0127 17V3C31.0127 1.89543 31.9081 1 33.0127 1H53.0127C54.1173 1 55.0127 1.89543 55.0127 3V17C55.0127 18.1046 54.1173 19 53.0127 19H33.0127C31.9081 19 31.0127 18.1046 31.0127 17Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0127 41V27C1.0127 25.8954 1.90813 25 3.01269 25H23.0127C24.1173 25 25.0127 25.8954 25.0127 27V41C25.0127 42.1046 24.1173 43 23.0127 43H3.0127C1.90813 43 1.0127 42.1046 1.0127 41Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21V7C1 5.89543 1.89543 5 3 5H23C24.1046 5 25 5.89543 25 7V21C25 22.1046 24.1046 23 23 23H3C1.89543 23 1 22.1046 1 21Z",
    fill: "white",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0127 41V27C27.0127 25.8954 27.9081 25 29.0127 25H49.0127C50.1173 25 51.0127 25.8954 51.0127 27V41C51.0127 42.1046 50.1173 43 49.0127 43H29.0127C27.9081 43 27.0127 42.1046 27.0127 41Z",
    fill: "white",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalIcon);
export default __webpack_public_path__ + "static/media/portalIcon.5d14ba7bb5656b8ad48450a2be2516e1.svg";
export { ForwardRef as ReactComponent };